import React, {Component} from 'react'
import { Form, Button } from 'react-bootstrap';
import ContactBreadcrumbsSection from '../components/ContactBreadcrumbsSection'
import { translate, Trans } from "react-i18next";
import {Helmet} from "react-helmet"
class Contact extends Component {
	constructor(props) {
		super(props)
	}
	render () {
        let t = this.props.t
		return (
			<React.Fragment>
			<main role="main">
				<ContactBreadcrumbsSection title="contact_breadcrumbs_section_title" subTitle="contact_breadcrumbs_section_sub_title"/>
				<section className="section-contact" id="section-six">
            	<div className="container">
                	 <header role="title-page" className="text-center">
                        <h4>Get in touch</h4>
                        <h2>Have any questions? Our team will happy to<br/>answer your questions.</h2>
                    </header>
                    <div className="contact-form">
                        <div id="message"></div>
                            <form name="cform" id="cform">
                            	<div className="container">
                            		<div className="row">
                            			<div className="col-md-6 col-lg-6 col-sm-12">
                                	<input name="name" id="name" type="text" placeholder={t('fullname')  + ' (*)' }/>
                                </div>
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                	<input name="email" id="email" type="email" placeholder={t('email_address')  + ' (*)' }/>
                                </div>
                            		</div>
                                </div>
                                <div className="clearfix">
                                </div>
                                <textarea name="comments" id="comments" cols="" rows="" placeholder={t('your_message')  + ' (*)' }></textarea>
                                <div className="clearfix"></div>
                                <div id="simple-msg"><p className="mutex" style = {{color: '#e31e25'}}>{t('required_field')}</p></div>
                                <input name="" type="button" value={t('send_mail')}/>
                        	</form>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </section>
			</main>
			</React.Fragment>
		)
	}
}
export default translate("translations") (Contact);
/*
<Form>
					<Form.Group controlId="formBasicEmail">
						<Form.Label>Email address</Form.Label>
						<Form.Control type="email" placeholder="Enter email" />
						<Form.Text className="text-muted">We'll never share your email with anyone else.
						</Form.Text>
					</Form.Group>
					<Form.Group controlId="formBasicPassword">
						<Form.Label>Password</Form.Label>
						<Form.Control type="password" placeholder="Password" />
						</Form.Group>
					<Form.Group controlId="formBasicChecbox">
						<Form.Check type="checkbox" label="Check me out" />
					</Form.Group>
					<Button variant="primary" type="submit">
					Submit
					</Button>
				</Form>
*/